module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toctb",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/about#about"
    }
  }, [_vm._v("About This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallt"
  }, [_vm._v("Chapter 1")])]), _c('br'), _vm._v("The Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallt"
  }, [_vm._v("Chapter 2")])]), _c('br'), _vm._v("Tried & True Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallt"
  }, [_vm._v("Chapter 3")])]), _c('br'), _vm._v("Beginner Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Moon Phase Tote Bag")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Geometric Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Botanical Curtains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Herb Pouches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclevb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Sunnies Case")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallt"
  }, [_vm._v("Chapter 4")])]), _c('br'), _vm._v("Intermediate Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Peacock Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Creating Your Own Wool Canvas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Nighttime in the Forest Wall Art")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Galaxy Place Mats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Forest Finds Patches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclevb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Bunny Brooch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "smallt"
  }, [_vm._v("Chapter 5")])]), _c('br'), _vm._v("Advanced Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Goldfinch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05lev2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Donut Wall Hanging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05lev3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Orange & Blossom Table Runner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclev"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Floral Cardigan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toclevb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ch05#ch05lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Panda Portrait")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/patterns#patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "undert",
    attrs: {
      "href": "#/xhtml/resources#resources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0